import { BOA_KEY, loansUrls, VERSION } from "../../constants/ApiUrls";
import { getData, updateData } from "../../networkManager/NetworkManager";

export const getLoans = async (id) => {
  return await getData(BOA_KEY + VERSION + `${id}/${loansUrls.GET_LOANS}`);
};
export const updateUserLoans = async (data, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${loansUrls.SAVE_LOANS}`,
    data
  );
};
